'use strict';

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Brand } from '@/lenses/uilenses/theme/colors';

/** Accent bar + heading — matches Product Fit / XD study builder sections */
export function StudyBuilderSectionTitle({ title, component = 'h3' }) {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, mt: 0.5 }}>
			<Box
				sx={{
					width: 4,
					height: 26,
					borderRadius: 1,
					background: `linear-gradient(180deg, ${Brand.activatedRed} 0%, ${Brand.insightfulOrange} 100%)`,
				}}
			/>
			<Typography
				component={component}
				variant="subtitle1"
				sx={{ fontWeight: 700, color: Brand.darkModeBlue, letterSpacing: '0.02em', lineHeight: 1.3 }}
			>
				{title}
			</Typography>
		</Box>
	);
}

export const studyBuilderGradientTopSx = {
	content: '""',
	display: 'block',
	height: 4,
	background: `linear-gradient(90deg, ${Brand.molecularBlue} 0%, ${Brand.livingPurple} 50%, ${Brand.activatedRed} 100%)`,
};
